/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.InteracMoneyRequestResponse | undefined,
  InteracMoneyRequest: (params: vp.InteracMoneyRequestRequest) => void,
  InteracMoneyRequestAsync: (params: vp.InteracMoneyRequestRequest) => Promise<vp.InteracMoneyRequestResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostInteracMoneyRequest: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldInteracMoneyRequest, setShouldInteracMoneyRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.InteracMoneyRequestRequest>();
  const [response, setResponse] = useState<vp.InteracMoneyRequestResponse>();

  useEffect(() => {
    if (!shouldInteracMoneyRequest) return () => {};

    const PostInteracMoneyRequest = async (postParams: vp.InteracMoneyRequestRequest) => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postInteracMoneyRequest(postParams, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldInteracMoneyRequest && params) void PostInteracMoneyRequest(params);
    setShouldInteracMoneyRequest(false);
    return () => {
      source.cancel();
    };
  }, [shouldInteracMoneyRequest]);

  return [
    response,
    (_params: vp.InteracMoneyRequestRequest) => {
      setParams(_params);
      setShouldInteracMoneyRequest(true);
    },
    (_params: vp.InteracMoneyRequestRequest) => api.postInteracMoneyRequest(_params, source),
    () => {
      setResponse(undefined);
      setShouldInteracMoneyRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostInteracMoneyRequest);
